"use strict";

angular
  .module(ApplicationConfiguration.applicationModuleName)
  .factory("BonusRequest", [
    "$resource",
    "$stateParams",
    "apiSettings",
    function ($resource, $stateParams, apiSettings) {
      return $resource(
        apiSettings.baseUri + "v1/bonuses-and-sponsorships/:id",
        { id: "@id" },
        {
          list: {
            url: apiSettings.baseUri + "v1/bonuses-and-sponsorships/list",
            method: "GET",
            isArray: false,
            params: {
              page: 1,
              pageSize: apiSettings.defaultPageSize,
            },
          },
          dashboard: {
            url: apiSettings.baseUri + 'v1/bonuses-and-sponsorships/dashboard',
            method: 'GET',
            isArray: false
          },
          dashboardPage: {
            url: apiSettings.baseUri + "v1/bonuses-and-sponsorships/dashboard-page",
            method: "GET",
            isArray: false,
            params: {
              page: 1,
              pageSize: apiSettings.defaultPageSize,
            },
          },
          subAreas: {
            url: apiSettings.baseUri + "v1/bonuses-and-sponsorships/sub-areas",
            method: "GET",
            isArray: true,
            params: {
              all: true
            },
          },
          status: {
            url: apiSettings.baseUri + "v1/bonuses-and-sponsorships/status",
            method: "GET",
            isArray: true,
          },
          types: {
            url: apiSettings.baseUri + "v1/bonuses-and-sponsorships/types",
            method: "GET",
            isArray: true,
          },
          deposits: {
            url: apiSettings.baseUri + "v1/bonuses-and-sponsorships/deposits",
            method: "GET",
            isArray: true,
          },
          productLines: {
            url:
              apiSettings.baseUri + "v1/bonuses-and-sponsorships/product-lines",
            method: "GET",
            isArray: true,
          },
          customerList: {
            url: apiSettings.baseUri + "v1/bonuses-and-sponsorships/customers",
            method: "GET",
            isArray: true,
          },
          solicitants: {
            url: apiSettings.baseUri + "v1/bonuses-and-sponsorships/solicitors",
            method: "GET",
            isArray: true,
          },
          workFlowApproval: {
            url:
              apiSettings.baseUri +
              "v1/workflowapprovals/bonuses-and-sponsorships",
            method: "PUT",
          },
          cancel: {
            url: apiSettings.baseUri + "v1/workflowapprovals/cancel",
            method: "POST",
          },
          insert: {
            method: "POST",
          },
          update: {
            method: "PUT",
          },
          delete: {
            method: "DELETE",
          },
        }
      );
    },
  ]);
